import React from "react";
import { Box, Switch, Typography, Alert, Autocomplete, TextField } from "@mui/material";

const BulkFlagInput = ({
    type = "switch",
    label,
    value,
    onChange,
    alertText,
    options = [],
    disabled = false,
    ...rest
}) => {
    return (
        <>
            <Typography margin={2} variant="h6">
                {label}
            </Typography>
            {alertText && (
                <Box mb={2} ml={1} mr={2}>
                    <Alert variant="outlined" severity="info">
                        {alertText}
                    </Alert>
                </Box>
            )}
            <Box mb={2} ml={2} mr={2}>
                {type === "switch" && (
                    <Switch
                        checked={!!value}
                        onChange={(event) => onChange(event.target.checked)}
                        disabled={disabled}
                    />
                )}
                {type === "autocomplete" && (
                    <Autocomplete
                        multiple
                        options={options}
                        value={value}
                        onChange={(event, newValue) => onChange(newValue)}
                        renderInput={(params) => <TextField {...params} />}
                        disabled
                        {...rest}
                    />
                )}
            </Box>
        </>
    );
};

export default BulkFlagInput;
